import { confidenceBadgeClass } from "../../../constants/foodAccessConfidence";

const FoodAccessConfidenceBadge = ({
  score,
  label,
  publicLabel,
  size = "md",
  showTooltip = false,
  reasons = [],
  warnings = [],
}) => {
  const displayLabel = publicLabel || label || "Needs review";
  const badgeClass = `${confidenceBadgeClass(label)} food-confidence-badge food-confidence-badge--${size}`;

  return (
    <span className="food-confidence-badge-wrap" title={showTooltip ? undefined : displayLabel}>
      <span className={badgeClass}>{displayLabel}</span>
      {showTooltip && (reasons.length || warnings.length || score != null) ? (
        <span className="food-confidence-badge__tooltip" role="tooltip">
          {score != null ? <strong>Score: {score}</strong> : null}
          {reasons.length ? (
            <ul>
              {reasons.map((reason) => (
                <li key={reason}>{reason}</li>
              ))}
            </ul>
          ) : null}
          {warnings.length ? (
            <ul className="food-confidence-badge__warnings">
              {warnings.map((warning) => (
                <li key={warning}>{warning}</li>
              ))}
            </ul>
          ) : null}
        </span>
      ) : null}
    </span>
  );
};

export default FoodAccessConfidenceBadge;
